import React from "react";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import OutlinedInput from "@mui/material/OutlinedInput";

const MuiInput = ({
  inputType,
  onChangeFunction,
  StateValues,
  placeholderTitles,
  name,
  labelTitle
}) => {
  return (
    <Box>
        <div className='admin-add-label'>
        <label htmlFor={labelTitle}>{labelTitle}:</label>
        </div>
      <FormControl sx={{ width: "100%" }} variant="outlined">
        <OutlinedInput
          id="outlined-adornment-weight"
          aria-describedby="outlined-weight-helper-text"
          type={inputType}
          name={name}
          placeholder={placeholderTitles}
          value={StateValues}
          onChange={onChangeFunction}
        />
      </FormControl>
    </Box>
  );
};

export default MuiInput;
